const config = {
  // BASEURL: "http://localhost:5543/v1/",
  // SOCKETURL: "http://localhost:5543/",
  BASEURL: "https://api.dev.zone5.ai/v1/", //dev
  SOCKETURL: "https://api.dev.zone5.ai", //dev
  // BASEURL: "https://api.staging.zone5.ai/v1/", //stage
  // SOCKETURL: "https://api.staging.zone5.ai", //stage
  API_KEY: "q-f2b9e48a-f05f-4e58-b5c3-3120e815e931",
  AWS_URL: "https://rabbitholebucket.s3.eu-north-1.amazonaws.com/",
  // IMAGEBASEURL: "http://localhost:6545/",
  // IMAGEBASEURL: "http://78.46.210.25:6545/",
  IMAGEBASEURL: "https://api.dev.zone5.ai/",
  // IMAGEBASEURL: "https://api.staging.zone5.ai/",
  GOOGLEMAPAPIKEY: "AIzaSyCDHZcdaGc3NYsnl4pNp1Tg5dkFfWSeRdU",
  lat: 24.7136,
  lng: 46.6753,
};
export default config;
